// extracted by mini-css-extract-plugin
module.exports = {"container":"_3zXAJ8hovequ25LtRsyv31"};